module.exports = __webpack_public_path__ + "assets/img/voucherDemo.b9377bf1.png";